<template>
  <BottomSheet
    :model-value="modelValue"
    :title="title"
    :icon="icon"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <!-- Sous-titre sous le titre (et non à côté comme la prop subtitle de BottomSheet) -->
    <template v-if="$slots.subtitle || subtitle" #subtitle>
      <slot name="subtitle">
        <p class="mobile-actions-menu__subtitle">{{ subtitle }}</p>
      </slot>
    </template>

    <div class="mobile-actions-menu">
      <div v-if="$slots.default" class="mobile-actions-menu__items">
        <slot />
      </div>
      <Button
        v-if="primaryText"
        variant="primary"
        mobile
        :danger="primaryDanger"
        :disabled="primaryDisabled"
        :loading="primaryLoading"
        class="mobile-actions-menu__primary"
        @click="emit('primary')"
      >
        {{ primaryText }}
      </Button>
    </div>
  </BottomSheet>
</template>

<script setup lang="ts">
// Enveloppe commune des menus d'actions mobiles : lignes MenuItem dans le slot,
// action principale en bouton plein tout en bas (zone du pouce). Aucune suppression ici :
// elle vit en bas du formulaire d'édition (MobileForm deleteText).
import BottomSheet from '@/components/BottomSheet.vue'
import Button from '@/components/Button.vue'

withDefaults(defineProps<{
  modelValue: boolean
  title: string
  subtitle?: string
  icon?: string
  primaryText?: string
  // Rouge plein : réservé au cas où l'unique action du menu est destructive (déconnexion)
  primaryDanger?: boolean
  primaryDisabled?: boolean
  primaryLoading?: boolean
}>(), {
  subtitle: undefined,
  icon: undefined,
  primaryText: undefined,
  primaryDanger: false,
  primaryDisabled: false,
  primaryLoading: false,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'primary'): void
}>()
</script>

<style scoped>
.mobile-actions-menu__subtitle {
  margin: 0;
  font-family: Outfit, sans-serif;
  font-size: 15px;
  color: var(--text-secondary);
}

.mobile-actions-menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px 24px;
}

.mobile-actions-menu__items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-actions-menu__primary {
  width: 100%;
  margin-top: 4px;
}
</style>
